import { gsap } from 'gsap'
import axios from 'axios'

const qs = require('qs')
const prod = process.env.NODE_ENV === 'production'
const lib = require('../library')
const cartUtils = require('./utils/cartUtils')

export default class CartAddProduct {
  constructor(el) {
    this.el = el
    this.setVars()
    this.init()
  }

  setVars() {
    this.button = this.el.querySelector('.js-purchasableId')
    this.loadingText = 'Adding'
    if (this.button) {
      this.purchaseableId = this.button.value
      this.miniCart = document.querySelector('[data-mini-cart]')

      this.miniCartCount = document.querySelector(
        '[data-mini-cart-count]',
      )
      this.adding = this.el.querySelector('[data-adding]')
      this.success = this.el.querySelector('[data-success]')
    }
  }

  init() {
    if (this.button) {
      this.el.addEventListener('submit', this.handleCartAdd)
    }
  }

  updateCart(count) {
    if (count === 1) {
      if (this.miniCartCount) {
        this.miniCartCount.innerHTML = count
      }
      this.handleShowCart()
    } else {
      this.handleNumberSwap(count)
    }
  }

  handleNumberSwap(count) {
    const aniNumbers = gsap.timeline({ duration: 0.05 })
    aniNumbers.eventCallback('onUpdate', () =>
      fnUpdate)
    function fnUpdate() {}
    aniNumbers
      .to(this.miniCartCount, {
        opacity: 0,
        y: '+=10',
      })
      .add(() => {
        this.miniCartCount.innerHTML = count
      })
      .to(
        this.miniCartCount,
        {
          opacity: 1,
          y: '0',
        },
        '<',
      )
  }

  handleShowCart() {
    if (!this.miniCart || typeof this.miniCart === 'undefined') {
      return false
    }
    const aniOutIn = gsap.timeline({ duration: 1 })
    this.miniCart.classList.remove('opacity-0')
    aniOutIn.from(
      this.miniCart,
      {
        opacity: 0,
        y: '-=20',
      },
      '<',
    )
  }

  handleAddingButton() {
    this.button.style.width = `${this.button.offsetWidth}px`
    this.button.classList.add('text-center')
    this.button.innerHTML = this.loadingText
    this.button.classList.add('s-cart-adding')
  }

  handleSuccessButton() {
    this.button.classList.remove('s-cart-adding')
    this.button.classList.add('s-cart-success')
    this.adding.classList.add('hidden')
    this.success.classList.remove('hidden')
  }

  handleCartAdd = (e) => {
    this.el.classList.add('s-loading')
    this.handleAddingButton()
    e.preventDefault()
    const data = {
      action: 'commerce/cart/update-cart',
      purchasableId: this.purchaseableId,
    }

    const options = {
      method: 'post',
      url: '/',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-CSRF-Token': window.CSRFToken,
      },
      data: qs.stringify(data),
    }
    axios(options)
      .then((response) => {
        console.log('added to cart')
        this.updateCart(response.data.cart.totalQty)
        this.el.classList.remove('s-loading')
        this.handleSuccessButton()
        cartUtils.cartOpenClose('open')
        e.preventDefault()
      })
      .catch((error) => {
        lib.logError(error)
      })
  }
}
